import React from 'react'
import { Box, Button, Modal, Typography } from '@mui/material'
import { useStore } from '../../../Stores/store';
import { observer } from 'mobx-react-lite';

export default observer(function ConfirmEventDeleteModal() {
    const { generalStore } = useStore();
    const { isEventConfirmationModalOpen, setEventConfirmationModalStatus, deleteEvent, deleteEventId } = generalStore; 

    return (
        <Modal
        open={isEventConfirmationModalOpen}
        onClose={() => setEventConfirmationModalStatus(false)}
        >
            <Box sx={{backgroundColor: "white", width:"90%", margin:"8em auto", borderRadius:"5px"}}>
                <Box sx={{padding: "1em" }}>
                    <Typography variant="h5">Confirm Delete</Typography>
                    <Typography sx={{color: "black", textAlign: "left"}}>Are you sure you want to delete this event?</Typography>
                    <Button onClick={() => deleteEvent(deleteEventId)} variant="contained" color={"warning"} sx={{margin: "0.3em", marginLeft:"0px"}}>Delete</Button>
                    <Button color={"info"} onClick={() => setEventConfirmationModalStatus(false)} sx={{margin: "0.3em"}} variant="contained">Cancel</Button>
                </Box>
            </Box>
        </Modal>
    )
});